<template>
  <div :class="$style.frameParent">
    <AddEditAircraft
      @save="closeEditAircraftOverlay"
      @close="closeEditAircraftOverlay"
      :aircraft="aircraft"
      :isVisible="addEditAircraftFormIsVisible"
      placement="Centered"
      :isEdit="true"
    />
    <div :class="$style.eparrowUpBoldParent">
      <img
        :class="$style.eparrowUpBoldIcon"
        alt=""
        src="/static/img/LeftChevron.svg"
        @click="backToAircraft"
      />
      <div :class="$style.n2361rPiperContainer">
        <b>
          <span>{{ this.aircraft.tailNumber }}</span>
        </b>
        <span :class="$style.piperPa28151">
          <b> </b>
          <span>| {{ this.aircraft.model }}</span>
        </span>
      </div>
      <div :class="$style.editParent" @click="openEditAircraftOverlay">
        <div :class="$style.search">Edit</div>
        <img :class="$style.vectorIcon11" alt="" src="/static/img/Write.svg" />
      </div>
    </div>
    <div :class="$style.frameParent1">
      <img :class="$style.aircraftImage" :src="aircraft.image" alt="Aircraft" />
      <div :class="$style.frameParent2">
        <div :class="$style.frameParent3">
          <div :class="$style.nextMaintenanceDueParent">
            <div :class="$style.nextMaintenanceDue">Next maintenance due</div>
            <div :class="$style.h" :style="'color: ' + getColor">
              {{ parseFloat(totalHours).toFixed(1) }}h
            </div>
          </div>
          <div :class="$style.frameParent4">
            <div :class="$style.hobbsParent">
              <div :class="$style.nextMaintenanceDue">Hobbs</div>
              <div :class="$style.div">
                {{ this.aircraft.hobbs ? this.aircraft.hobbs : "NO DATA" }}
              </div>
            </div>
            <div :class="$style.hobbsParent">
              <div :class="$style.nextMaintenanceDue">Engine 1 Tach</div>
              <div :class="$style.div">
                {{ this.aircraft.tach ? this.aircraft.tach : "NO DATA" }}
              </div>
            </div>
          </div>
        </div>
        <div
          :class="$style.scheduleMaintenanceWrapper"
          @click="openReservationPopup"
        >
          <div :class="$style.nextMaintenanceDue">Schedule Maintenance</div>
        </div>
      </div>
      <div :class="$style.dateParent">
        <div :class="$style.date">
          <div :class="$style.dateChild" />
          <div
            v-for="inspectionType in inspectionTypes"
            :key="'icon-' + inspectionType.name"
            :class="$style.iconWrapperContainer"
          >
            <div :class="$style.iconWrapper">
              <img
                :class="$style.planeIcon"
                alt=""
                :src="
                  '/static/img/airplane_' +
                  getPlaneColor(inspectionType.id) +
                  '.svg'
                "
                :style="
                  'opacity: ' +
                  (getPlaneColor(inspectionType.id) === 'grey' ? '.4' : '1')
                "
              />
            </div>
          </div>
          <div :class="$style.emptyDiv3" />
        </div>

        <div :class="$style.date1">
          <div :class="$style.inspectionsMaintenanceWrapper">
            <div :class="$style.nextMaintenanceDue">
              Inspections & Maintenance
            </div>
          </div>
          <div
            v-for="(inspection, index) in inspectionTypes"
            :key="'text-' + index"
            :class="$style.textWrapper"
          >
            <div :class="$style.text">{{ inspection.name }}</div>
          </div>
          <div :class="$style.emptyDiv4" />
        </div>

        <div :class="$style.headerSection5">
          <div :class="$style.dateChild" />
          <div
            v-for="(item, index) in inspectionTypes"
            :key="'view-' + index"
            :class="$style.dateInner8"
          >
            <div :class="$style.iconWrapper">
              <div
                :class="$style.text"
                @click="(event) => openWindow(item.id, 'view', event)"
              >
                View
              </div>
            </div>
          </div>
          <div :class="$style.dateInner14">
            <div :class="$style.emptyDiv4" />
          </div>
        </div>

        <div :class="$style.date3">
          <div :class="$style.dateChild" />
          <div
            v-for="(item, index) in inspectionTypes"
            :key="'update-' + index"
            :class="$style.updateWrapper"
          >
            <div
              :class="$style.text"
              @click="(event) => openWindow(item.id, 'update', event)"
            >
              Update
            </div>
          </div>
          <div :class="$style.dateInner14">
            <div :class="$style.emptyDiv4" />
          </div>
        </div>
      </div>
    </div>

    <div :class="$style.frameParent5">
      <div :class="$style.squawksParent">
        <b :class="$style.n2361rPiperContainer">Squawks</b>
        <div
          :class="$style.addParent"
          @click="openSquawkFormOverlay"
          v-if="canAddSquawk"
        >
          <div :class="$style.search">Add</div>
          <img
            :class="$style.vectorIcon11"
            alt=""
            src="/static/img/white_plus.svg"
          />
        </div>
      </div>
    </div>
    <div :class="$style.gridContainer" v-if="showSquawks">
      <div v-for="squawk in squawks" :key="'squawk-tile-' + squawk.id">
        <SquawkTile
          :squawk="squawk"
          :aircraft="aircraft"
          @showSquawkModal="viewSquawk"
        />
      </div>
    </div>
    <div v-else style="text-align: left">
      <h1>No squawks!</h1>
    </div>
    <div :class="$style.frameChild14" />

    <AddSquawk
      @close="closeSquawkFormOverlay"
      @save="saveSquawk"
      placement="Centered"
      :onOutsideClick="closeSquawkFormOverlay"
      :status="squawksStatus"
      :modalData="modalData"
      :isView="isView"
      :isEdit="isEdit"
      :isvisible="isSquawkFormOverlayOpen"
    />

    <reservation-modal
      v-if="showReservationModal"
      ref="reservation-modal"
      :event="null"
      is-maintenance
      @event-created="closeReservationPopup"
      @close="closeReservationPopup"
    ></reservation-modal>

    <InspectionsWindow
      v-if="showWindow"
      :mode="mode"
      :title="getInspectionTypeName(activeForm.inspectionTypeId)"
      :subtitle="
        activeForm.inspectionTypeId === hundredHourInspectionId
          ? '(Based on the Tachometer)'
          : ''
      "
      :form="activeForm"
      :triggerRect="triggerRect"
      :onClose="closeWindow"
      :onSave="mode === 'update' ? saveUpdate : null"
      :onDateChange="mode === 'update' ? updateNextDate : null"
      :onTachChange="mode === 'update' ? updateNextTach : null"
      :hundredHourInspectionId="hundredHourInspectionId"
    />
  </div>
</template>
<script>
import AddSquawk from "@/pages/Dashboard/HiloPages/Aircraft/AddSquawk.vue";
import SquawkTile from "@/pages/Dashboard/HiloPages/Aircraft/SquawkTile.vue";
import ReservationModal from "@/pages/Dashboard/HiloPages/Schedule/ReservationModal.vue";
import InspectionsWindow from "@/pages/Dashboard/HiloPages/Aircraft/InspectionsWindow.vue";
import AddEditAircraft from "@/pages/Dashboard/HiloPages/Aircraft/AddEditAircraft.vue";
import SquawksAPIService from "@/servicehandlers/SquawksAPIService.js";
import InspectionsAPIService from "src/servicehandlers/InspectionsAPIService";
import AircraftAPIService from "src/servicehandlers/AircraftAPIService";
import dayjs from "dayjs";
import { getProcessedImageUrl } from "@/util/images";
const squawksAPIService = new SquawksAPIService();
const inspectionsAPIService = new InspectionsAPIService();
const aircraftAPIService = new AircraftAPIService();

export default {
  name: "Frame",
  props: ["id"],
  components: {
    AddEditAircraft,
    AddSquawk,
    SquawkTile,
    ReservationModal,
    InspectionsWindow,
  },
  data() {
    return {
      inspectionTypes: [],
      addEditAircraftFormIsVisible: false,
      isSquawkFormOverlayOpen: false,
      squawks: [],
      showSquawks: false,
      showReservationModal: false,
      aircraft: {},
      showWindow: false,
      mode: "",
      hundredHourInspectionId: null,
      activeForm: {
        inspectionTypeId: null,
        lastDate: "",
        nextDate: "",
        lastTach: null,
        nextTach: null,
      },
      windowPosition: { top: 0, left: 0 },
      triggerRect: {},
      inspections: [],
      loading: false,
      squawksStatus: [],
      modalData: {},
      isView: false,
      isEdit: false,
    };
  },
  computed: {
    canAddSquawk() {
      return ["Admin", "Maintenance", "Instructor"].includes(
        this.$store.getUser.userType.name,
      );
    },
    getColor() {
      return this.aircraft?.aircraftStatus === "Active"
        ? "green"
        : this.aircraft?.aircraftStatus === "Inspection Due Soon"
          ? "orange"
          : "red";
    },
    nextVorInspection() {
      if (this.inspections.length === 0) {
        return { daysAway: null };
      }

      const vorInspection = this.inspections.find(
        (inspection) => inspection?.name === "VOR Inspection",
      );

      if (!vorInspection || !vorInspection.nextDate) {
        return { daysAway: null };
      }

      const daysAway = Math.ceil(
        dayjs(vorInspection.nextDate).diff(dayjs(), "hour") / 24,
      );

      let color = daysAway <= 7 ? "orange" : undefined;
      if (daysAway <= 0) {
        color = "red";
      }

      return {
        daysAway: daysAway > 0 ? daysAway : `Overdue by ${Math.abs(daysAway)}`,
        color,
      };
    },
    next100HoursInspection() {
      const upcomingHours = this.inspections
        .filter((inspection) => inspection.nextTach)
        .map((inspection) => inspection.nextTach - this.aircraft.tach);

      if (upcomingHours.length === 0 || !this.aircraft.tach) {
        return { hoursAway: null };
      }

      const soonestHours = Math.min(...upcomingHours);
      let hoursAway;
      let color;

      if (soonestHours > 0) {
        hoursAway = soonestHours.toFixed(1);
        if (soonestHours < 2) {
          color = "red";
        } else if (soonestHours <= 20) {
          color = "orange";
        }
      } else if (soonestHours === 0) {
        hoursAway = "0.0";
        color = "red";
      } else {
        hoursAway = `Overdue by ${Math.abs(soonestHours).toFixed(1)}`;
        color = "red";
      }

      return {
        hoursAway,
        color,
      };
    },
    nextOtherInspection() {
      if (this.inspections.length === 0) {
        return { daysAway: null };
      }

      const otherInspections = this.inspections.filter(
        (inspection) =>
          inspection?.name !== "VOR Inspection" && inspection.nextDate,
      );

      if (otherInspections.length === 0) {
        return { daysAway: null };
      }

      const soonestNonVor = otherInspections.reduce((earliest, current) => {
        const earliestDate = dayjs(earliest.nextDate);
        const currentDate = dayjs(current.nextDate);
        return earliestDate.isBefore(currentDate) ? earliest : current;
      });

      const daysAway = Math.ceil(
        dayjs(soonestNonVor.nextDate).diff(dayjs(), "hour") / 24,
      );

      let color = daysAway <= 30 ? "orange" : undefined;
      if (daysAway <= 0) {
        color = "red";
      }

      return {
        daysAway: daysAway > 0 ? daysAway : `Overdue by ${Math.abs(daysAway)}`,
        color,
      };
    },
    totalHours() {
      return this.next100HoursInspection.hoursAway;
    },
  },
  async mounted() {
    try {
      this.loading = true;

      if (!this.id) {
        this.backToAircraft();
      }

      await this.commonRequests();

      if (this.squawks[0]) {
        this.showSquawks = true;
      }
    } catch {
      //Do nothing
    } finally {
      this.loading = false;
    }
  },
  methods: {
    getPlaneColor(inspectionTypeId) {
      let color = "green";
      const inspection = this.inspections.find(
        (item) => item.inspectionTypeId === inspectionTypeId,
      );
      if (
        inspection === undefined ||
        (inspection &&
          inspection.nextDate === null &&
          inspection.nextTach === null)
      ) {
        return "grey";
      }
      if (inspectionTypeId === this.hundredHourInspectionId) {
        if (
          inspection?.nextTach &&
          this.aircraft.tach + 2 > inspection.nextTach
        ) {
          color = "red";
        } else if (
          inspection?.nextTach &&
          this.aircraft.tach >= inspection.nextTach - 20
        ) {
          color = "orange";
        }
      } else if (inspectionTypeId === this.vorInspectionId) {
        if (
          inspection?.nextDate &&
          dayjs().isAfter(dayjs(inspection.nextDate))
        ) {
          color = "red";
        } else if (
          inspection?.nextDate &&
          Math.ceil(dayjs(inspection.nextDate).diff(dayjs(), "hour") / 24) <= 7
        ) {
          color = "orange";
        }
      } else {
        if (
          inspection?.nextDate &&
          dayjs().isAfter(dayjs(inspection.nextDate))
        ) {
          color = "red";
        } else if (
          inspection?.nextDate &&
          Math.ceil(dayjs(inspection.nextDate).diff(dayjs(), "hour") / 24) <= 30
        ) {
          color = "orange";
        }
      }
      return color;
    },
    saveSquawk() {
      this.closeSquawkFormOverlay();
      this.aircraft = {};
      this.squawks = [];
      this.inspectionTypes = [];
      this.inspections = [];
      this.commonRequests();
    },
    async commonRequests() {
      const response = await aircraftAPIService.getById(this.id, this.$router);
      this.aircraft = {
        ...response,
        aircraftStatus: response.aircraftStatus?.name,
        // image: aircraftImage,
        // nextMaintenanceDate: "151",
        // next100HoursInspection: "1.7",
      };
      this.aircraft.image = getProcessedImageUrl(this.aircraft.image);
      await this.getAircraftSquawks();
      await this.getInspectionTypes();
      await this.getInspectionsByAircraft();
      await this.getSquawksStatus();
    },
    openWindow(inspectionTypeId, mode, event) {
      const triggerRect = event.target.getBoundingClientRect();

      const inspection = this.inspections.find(
        (item) => item.inspectionTypeId === inspectionTypeId,
      );

      this.activeForm = {
        inspectionTypeId,
        lastDate: inspection?.lastDate || "",
        nextDate: inspection?.nextDate || "",
        lastTach: inspection?.lastTach || null,
        nextTach: inspection?.nextTach || null,
      };

      this.mode = mode;
      this.triggerRect = {
        top: triggerRect.top,
        bottom: triggerRect.bottom - 85,
        left: triggerRect.left,
        right: triggerRect.right,
        width: triggerRect.width,
        height: triggerRect.height,
      };
      this.showWindow = true;
    },
    closeWindow() {
      this.showWindow = false;
      this.activeForm = {
        inspectionTypeId: null,
        lastDate: "",
        nextDate: "",
        lastTach: null,
        nextTach: null,
      };
    },
    async saveUpdate(updatedForm) {
      try {
        const payload = {
          inspectionTypeId: updatedForm.inspectionTypeId,
          aircraftId: this.aircraft.id,
        };

        if (updatedForm.inspectionTypeId === this.hundredHourInspectionId) {
          payload.lastTach = updatedForm.lastTach;
          payload.nextTach = updatedForm.nextTach;
        } else {
          payload.lastDate = updatedForm.lastDate
            ? dayjs(updatedForm.lastDate).utc().format()
            : null;
          payload.nextDate = updatedForm.nextDate
            ? dayjs(updatedForm.nextDate).utc().format()
            : null;
        }

        const existingInspection = this.inspections.find(
          (inspection) =>
            inspection.inspectionTypeId === updatedForm.inspectionTypeId,
        );

        if (existingInspection) {
          await inspectionsAPIService.update(
            existingInspection.id,
            payload,
            this.$router,
          );
        } else {
          await inspectionsAPIService.create(payload, this.$router);
        }

        await this.refreshData();
        this.closeWindow();
      } catch (error) {}
    },
    getInspectionTypeName(inspectionTypeId) {
      const inspectionType = this.inspectionTypes.find(
        (type) => type.id === inspectionTypeId,
      );
      return inspectionType ? inspectionType.name : "Unknown Inspection";
    },
    async refreshData() {
      await this.getInspectionsByAircraft();
    },
    async getSquawksStatus() {
      try {
        this.squawksStatus = await squawksAPIService.getStatuses(this.$router);
      } catch (error) {}
    },
    async getInspectionsByAircraft() {
      try {
        this.inspections = await inspectionsAPIService.getByAircraftId(
          this.aircraft.id,
          this.$router,
        );
      } catch (error) {}
    },
    async getInspectionTypes() {
      try {
        this.inspectionTypes = await inspectionsAPIService.getInspectionTypes(
          this.$router,
        );
        const hundredHourInspection = this.inspectionTypes.find(
          (type) => type.name === "100 Hour Inspection",
        );
        this.hundredHourInspectionId = hundredHourInspection?.id || null;

        const altimeterInspection = this.inspectionTypes.find(
          (type) =>
            type.name === "Altimeter and Pitot Static System Inspection",
        );
        this.altimeterInspectionId = altimeterInspection?.id || null;

        const vorInspection = this.inspectionTypes.find(
          (type) => type.name === "VOR Inspection",
        );
        this.vorInspectionId = vorInspection?.id || null;
      } catch (error) {}
    },
    async getAircraftSquawks() {
      return squawksAPIService
        .getByAircraftId(this.aircraft.id, this.$router)
        .then((response) => {
          this.squawks = response;
        })
        .catch(() => {});
    },
    openEditAircraftOverlay() {
      this.addEditAircraftFormIsVisible = true;
    },
    async closeEditAircraftOverlay(bool = false) {
      this.addEditAircraftFormIsVisible = false;
      if (bool) await this.commonRequests();
    },
    openSquawkFormOverlay() {
      this.isSquawkFormOverlayOpen = true;
      this.modalData = { aircraft: this.aircraft };
    },
    viewSquawk({ aircraft, squawk }, type) {
      this.isSquawkFormOverlayOpen = true;
      this.modalData = { aircraft, squawk };
      this[type] = true;
      if (type === "isEdit") this.isView = false;
      if (type === "isView") this.isEdit = false;
      this.$forceUpdate();
    },
    closeSquawkFormOverlay() {
      this.isSquawkFormOverlayOpen = false;
      this.modalData = {};
      this.isEdit = false;
      this.isView = false;
      this.$forceUpdate();
    },
    updateNextDate(newDate) {
      this.activeForm.lastDate = newDate;

      const inspectionType = this.inspectionTypes.find(
        (type) => type.id === this.activeForm.inspectionTypeId,
      );

      if (inspectionType?.interval && this.activeForm.lastDate) {
        let calculatedDate = dayjs(this.activeForm.lastDate).add(
          inspectionType.interval,
          inspectionType.intervalType,
        );

        if (inspectionType.intervalType === "month") {
          calculatedDate = calculatedDate.endOf("month");
        }

        this.activeForm.nextDate = calculatedDate.format("YYYY-MM-DD");
      }
    },
    updateNextTach(newTach) {
      this.activeForm.lastTach = newTach;

      const inspectionType = this.inspectionTypes.find(
        (type) => type.id === this.activeForm.inspectionTypeId,
      );

      if (inspectionType?.interval && this.activeForm.lastTach) {
        this.activeForm.nextTach =
          Number(this.activeForm.lastTach) + Number(inspectionType.interval);
      }
    },
    openReservationPopup() {
      this.showReservationModal = true;
    },
    closeReservationPopup() {
      this.showReservationModal = false;
    },
    backToAircraft() {
      this.$router.push({ name: "Aircraft" });
    },
  },
};
</script>
<style module scoped>
.gridContainer {
  width: 100%;
  padding: 0 50px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 40px;
}
.search {
  position: relative;
  line-height: 25px;
}

.eparrowUpBoldIcon {
  width: 16px;
  position: relative;
  height: 16px;
  overflow: hidden;
  flex-shrink: 0;
  object-fit: contain;
  cursor: pointer;
}
.piperPa28151 {
  font-size: 40px;
}
.n2361rPiperContainer {
  flex: 1;
  position: relative;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.eparrowUpBoldParent {
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 0 50px 0 19px;
  gap: 20px;
  z-index: 3;
  text-align: left;
  font-size: 55px;
}

.aircraftImage {
  align-self: stretch;
  width: 226px;
  position: relative;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
  border-radius: 15px;
  background-color: #fff;
  overflow: hidden;
  flex-shrink: 0;
}
.nextMaintenanceDue {
  position: relative;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.h {
  position: relative;
  font-size: 80px;
  /* color: #404040; */
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.nextMaintenanceDueParent {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.div {
  position: relative;
  font-size: 50px;
  color: #404040;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.hobbsParent {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 5px;
}
.frameParent4 {
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  font-size: 15px;
}
.frameParent3 {
  align-self: stretch;
  flex: 1;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
  border-radius: 15px;
  background-color: #fff;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 20px 30px 25px;
}
.scheduleMaintenanceWrapper {
  align-self: stretch;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
  border-radius: 10px;
  background-color: #a148ad;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 10px;
  cursor: pointer;
  font-size: 15px;
  color: #fff;
}
.frameParent2 {
  align-self: stretch;
  width: 625px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 10px;
}
.dateChild {
  align-self: stretch;
  background-color: #a148ad;
  height: 37px;
}
.planeIcon {
  width: 17px;
  position: relative;
  height: 17px;
}
.iconWrapper {
  align-self: stretch;
  border-right: 0.3px solid rgba(64, 64, 64, 0.5);
  border-bottom: 0.5px solid rgba(64, 64, 64, 0.5);
  border-left: 0.5px solid rgba(64, 64, 64, 0.5);
  box-sizing: border-box;
  height: 27px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 5px 10px;
}
.iconWrapperContainer {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
}
.emptyDiv3 {
  align-self: stretch;
  border-bottom: 0.5px solid rgba(64, 64, 64, 0.5);
  border-left: 0.5px solid rgba(64, 64, 64, 0.5);
  box-sizing: border-box;
  height: 27px;
}
.date {
  border-radius: 15px 0 0 0;
  background-color: #fff;
  border-top: 0.5px solid rgba(64, 64, 64, 0.5);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  z-index: 3;
}
.inspectionsMaintenanceWrapper {
  align-self: stretch;
  background-color: #a148ad;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: 7.5px;
  text-align: center;
  color: #fff;
}
.text {
  position: relative;
  line-height: 13px;
}
.textWrapper {
  align-self: stretch;
  border-right: 0.3px solid rgba(64, 64, 64, 0.5);
  border-bottom: 0.5px solid rgba(64, 64, 64, 0.5);
  border-left: 0.5px solid rgba(64, 64, 64, 0.5);
  box-sizing: border-box;
  height: 27px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: 5px 10px;
}
.date1 {
  background-color: #fff;
  border-top: 0.5px solid rgba(64, 64, 64, 0.5);
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  z-index: 2;
  color: #404040;
}
.dateInner8 {
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  cursor: pointer;
}
.emptyDiv4 {
  align-self: stretch;
  border-bottom: 0.5px solid rgba(64, 64, 64, 0.5);
  box-sizing: border-box;
  height: 27px;
}
.dateInner14 {
  align-self: stretch;
  height: 27px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
}
.headerSection5 {
  background-color: #fff;
  border-top: 0.5px solid rgba(64, 64, 64, 0.5);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  z-index: 1;
}
.updateWrapper {
  border-right: 0.3px solid rgba(64, 64, 64, 0.5);
  border-bottom: 0.5px solid rgba(64, 64, 64, 0.5);
  border-left: 0.5px solid rgba(64, 64, 64, 0.5);
  box-sizing: border-box;
  height: 27px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 5px 10px;
  cursor: pointer;
}
.date3 {
  background-color: #fff;
  border-top: 0.5px solid rgba(64, 64, 64, 0.5);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  z-index: 0;
}
.dateParent {
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
  border-radius: 15px;
  border: 0.5px solid #9f9f9f;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  text-align: left;
  font-size: 15px;
  color: #3c78ff;
}
.frameParent1 {
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 0 50px;
  gap: 30px;
  z-index: 2;
  font-size: 30px;
  color: rgba(64, 64, 64, 0.75);
}
.vectorIcon11 {
  width: 17px;
  position: relative;
  height: 17px;
}
.addParent {
  width: 100px;
  border-radius: 5px;
  background-color: #3c78ff;
  height: 29px;
  overflow: hidden;
  flex-shrink: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 0 10px;
  box-sizing: border-box;
  gap: 5px;
  cursor: pointer;
  text-align: center;
  font-size: 18px;
  color: #fff;
}
.editParent {
  width: 100px;
  border-radius: 5px;
  background-color: #ffa42d;
  height: 29px;
  overflow: hidden;
  flex-shrink: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 0 10px;
  box-sizing: border-box;
  gap: 5px;
  cursor: pointer;
  text-align: center;
  font-size: 18px;
  color: #fff;
}
.squawksParent {
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 10px;
  font-size: 25px;
}
.frameParent5 {
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 0 50px;
  gap: 15px;
  z-index: 1;
  text-align: left;
  font-size: 15px;
}
.frameChild14 {
  width: 100px;
  position: relative;
  height: 100px;
  overflow: hidden;
  flex-shrink: 0;
  z-index: 0;
}
.frameParent {
  height: 100%;
  flex: 1;
  width: 100%;
  position: relative;
  background-color: #f6f6f6;
  overflow-y: auto;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  gap: 50px;
  text-align: center;
  font-size: 18px;
  color: #404040;
  font-family: Helvetica, Arial, sans-serif;
}
</style>
